import { FaDollarSign } from "react-icons/fa6";
import NumberPicker from "../NumberPicker/NumberPicker";
import styles from "./MoneyInput.module.css";

export default function MoneyInput({ inputProps, slotProps, numberPicker }) {
	return (
		<div {...slotProps("control", styles.control)}>
			<FaDollarSign size={16} aria-hidden="true" {...slotProps("currencyIcon", styles.moneyIcon)} />
			<input {...inputProps} type="number" {...slotProps("field", styles.field)} />
			{numberPicker && <NumberPicker config={numberPicker} slotProps={slotProps} inputProps={inputProps} />}
		</div>
	);
}
